import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "./Layout/AppLayout";
import PropTypes from "prop-types";

const Protected = (props) => {
  const { Component,navigation } = props;
  const navigate = useNavigate();
  useEffect(() => {
    let accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      navigate("/");
    }
  });
  return (
    <Layout navigation={navigation} >
      <Component/>
    </Layout>
  );
};
Protected.propTypes = {
  Component: PropTypes.elementType.isRequired, 
};
export default Protected;
